import { extendTheme, theme } from '@chakra-ui/react';
import { LocalStoreService } from 'services/ZocalStore/local_store_service';

import { fixedColors } from './fixedColors';
import { colors } from './theme2/colors';
import { dark } from './theme2/dark';
import { light } from './theme2/light';
import {
  BodyFontFamily,
  fontSizes,
  fontWeights,
  HeadingFontFamily,
  radii,
  sizes,
  space,
} from './tokens';
import { colorOpacity } from './utils';

export { BodyFontFamily, HeadingFontFamily };

const colorMode = LocalStoreService.getChakraColorMode();
const primaryColor = props =>
  props.colorMode === 'dark' ? dark.primary : light.primary;

export const customTheme = extendTheme({
  ...theme,
  styles: {
    global: props => ({
      body: {
        fontSize: '16px',
        bg: props.colorMode === 'dark' ? '#141414' : colors.background,
        fontFamily: BodyFontFamily,
        //fontStyle: 'normal',
      },
      heading: {
        fontFamily: HeadingFontFamily,
      },
    }),
  },
  components: {
    Switch: {
      baseStyle: props => ({
        track: {
          background: theme.colors.gray['300'],
          borderRadius: 3,
          _checked: {
            background: primaryColor(props),
          },
        },
      }),
    },
    Progress: {
      baseStyle: props => ({
        filledTrack: {
          bg:
            props.colorMode === 'dark'
              ? `${props.colorScheme}.200`
              : `${props.colorScheme}.300`,
        },
      }),
    },
    Checkbox: {
      baseStyle: props => ({
        control: {
          borderColor: colors.gray['200'],
          borderWidth: '0.5px',
          background: 'white',
          _disabled: {
            opacity: 0.3,
            borderColor: colors.gray['300'],
            borderWidth: '0.5px',
          },
          _focus: {
            borderColor: primaryColor(props),
            boxShadow: `0 0 0 1px ${primaryColor(props)}`,
          },
          _checked: {
            background: primaryColor(props),
            borderColor: primaryColor(props),
            _disabled: {
              opacity: 0.3,
              background: '#fff',
              borderColor: primaryColor(props),
            },
            _hover: {
              background: primaryColor(props),
              borderColor: primaryColor(props),
              boxShadow: `0 0 0 1px ${primaryColor(props)}`,
            },
          },
          _indeterminate: {
            background: primaryColor(props),
            borderColor: primaryColor(props),
          },
        },
      }),
      sizes: {
        xs: { control: { borderRadius: 2 } },
        sm: { control: { borderRadius: 3 } },
        md: { control: { borderRadius: 5 } },
        lg: { control: { borderRadius: 7 } },
      },
    },
    Radio: {
      baseStyle: props => ({
        control: {
          _checked: {
            background: primaryColor(props),
            borderColor: primaryColor(props),
            _hover: {
              background: primaryColor(props),
              borderColor: primaryColor(props),
            },
          },
        },
      }),
    },
    Modal: {
      baseStyle: () => ({
        dialog: {
          top: '40px',
        },
      }),
    },
    Popover: {
      variants: {
        responsive: {
          popper: {
            maxWidth: 'unset',
            width: 'unset',
          },
        },
      },
    },
  },
  fonts: {
    ...theme.fonts,
    body: 'Rubik, Roboto, system-ui, sans-serif',
    heading: 'Rubik, Roboto, Georgia, serif', //Gilmer
  },
  config: {
    //useSystemColorMode: false,
    initialColorMode: 'light',
  },
  fontWeights,
  //breakpoints: [...theme.breakpoints, '90em'],
  sizes: {
    ...theme.sizes,
    ...sizes,
  },
  fontSizes: {
    ...theme.fontSizes,
    ...fontSizes,
  },
  space: {
    ...theme.space,
    ...space,
  },
  radii: {
    ...theme.radii,
    ...radii,
  },
  colors: {
    ...fixedColors,
    ...colors,
    ...(colorMode === 'dark' ? dark : light),
  },
});

export const colorMap = {
  primary(op: Opacity = 500) {
    return colorOpacity(customTheme.colors.primary, op / 500);
  },
};

type Opacity = 0 | 30 | 50 | 100 | 200 | 300 | 400 | 500;

//export const customTheme = light;
